import { publicCountryList } from "@mediately/countrykit-web";

export const COUNTRIES: string[] = publicCountryList().map((country) => country.toUpperCase());

export const CHART_COLORS = ["#8CB1FF", "#F49C51", "#FFDE90", "#7FBBB8"];
export const CHART_COLORS_SECONDARY = ["#FFDE90", "#7FBBB8"];
